import React, { useEffect, useState } from 'react';
import { FormGroup } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import Loader from '../../../Components/Utility/Loader/Loader';
import * as placeholderAction from './store/PlaceHolderManagement.action';

const customStyles = {
  option: (provided) => ({
    ...provided,
    padding: '5px 10px',
  }),
  container: () => ({
    // none of react-select's styles are passed to <Control />
    flex: '1',
    minWidth: 200,
    marginRight: 10,
  }),
  control: () => ({
    // none of react-select's styles are passed to <Control />
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    borderBottom: '1px solid #848484',
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';

    return { ...provided, opacity, transition };
  },
  menu: (provided) => ({
    ...provided,
    margin: '-9px 0 0 0',
    border: '1px solid #848484',
    borderRadius: 0,
    padding: 0,
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: 0,
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#000',
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: 'none',
  }),
};

function List({ data, isLoading }) {
  const tableHeaders = [
    { name: 'Category 1' },
    { name: 'Category 2' },
    { name: 'Category 3' },
    { name: 'Category 4' },
    { name: 'Product Description' },
    { name: 'Brand' },
    { name: 'Season' },
    { name: 'Month' },
    { name: 'Year' },
    { name: 'Newness Type' },
    { name: 'Sustainability' },
    { name: 'Price Brand' },
    { name: 'Target Price' },
    { name: 'Placeholder Quantity' },
    { name: 'Actual Quantity' },
  ];

  const {
    control,
    register,
    setValue,
    errors,

    placeholderManagementFields,
    placeholderManagementAppend,
    placeholderManagementRemove,
    loaderOnSubmit,
  } = useFormContext(); // retrieve all hook methods
  const dispatch = useDispatch();
  const reducer = useSelector((reducerstate) => reducerstate);
  const { t } = useTranslation('common');
  const { UserDetails } = reducer;
  const { userInfo } = UserDetails;
  const loggedInUserId = userInfo.userId;
  const [cat3Data, setCat3Data] = useState([]);
  const [cat4Data, setCat4Data] = useState([]);
  const [selected, setSelected] = useState({});

  const [state, setState] = useState({
    selectedField: {},
    fieldsData: {},
    categoryOneId: [],
    categoryTwoId: [],
    categoryThreeId: [],
    categoryFourId: [],
  });

  useFieldArray({
    control,
    name: 'placeholderManagement',
  });

  const nextCategory = async (catType) => {
    if ((catType === 1 || catType === 2) && !isEmpty(state.categoryOneId?.[`row_${state.index}`]) && !isEmpty(state.categoryTwoId?.[`row_${state.index}`])) {
      let res = [];
      res = await dispatch(
        placeholderAction.fetchCategoryAction({
          accessedFrom: 'masters',
          categoryType: 3,
          categoryOneId: state.categoryOneId[`row_${state.index}`],
          categoryTwoId: state.categoryTwoId[`row_${state.index}`],
          isActive: 1,
          loggedInUserId,
        }),
      );

      res = await createOptions(res);

      setCat3Data((prev) => ({
        ...prev,
        [`row_${state.index}`]: res,
      }));
    }

    if (
      (catType === 1 || catType === 2 || catType === 3) &&
      !isEmpty(state.categoryOneId?.[`row_${state.index}`]) &&
      !isEmpty(state.categoryTwoId?.[`row_${state.index}`]) &&
      !isEmpty(state.categoryThreeId?.[`row_${state.index}`])
    ) {
      let res = [];
      res = await dispatch(
        placeholderAction.fetchCategoryAction({
          accessedFrom: 'masters',
          categoryType: 4,
          categoryOneId: state.categoryOneId[`row_${state.index}`],
          categoryTwoId: state.categoryTwoId[`row_${state.index}`],
          categoryThreeId: state.categoryThreeId[`row_${state.index}`],
          isActive: 1,
          loggedInUserId,
        }),
      );

      res = await createOptions(res);

      setCat4Data((prev) => ({
        ...prev,
        [`row_${state.index}`]: res,
      }));
    }
  };

  const createOptions = async (array) => {
    let dataArray = [];
    if (array?.length) {
      dataArray = await array.map((item) => {
        return {
          label: item.name || item,
          value: item._id || item,
        };
      });
    }
    return dataArray;
  };

  const handleCatOneOnChange = async (value, i) => {
    setValue(`placeholderManagement[${i}].category3`, null, {
      shouldValidate: false,
    });

    setSelected((prev) => ({
      ...prev,
      [`placeholderManagement[${i}].category3`]: [],
    }));

    // setValue in form
    setValue(`placeholderManagement[${i}].category1`, value, {
      shouldValidate: true,
    });

    setSelected((prev) => ({
      ...prev,
      [`placeholderManagement[${i}].category1`]: value,
    }));

    const cat1Ids = value.value;
    setState((prev) => ({
      ...prev,
      categoryOneId: { ...prev.categoryOneId, [`row_${i}`]: cat1Ids },
      index: i,
    }));
  };

  const handleCatTwoOnChange = async (value, i) => {
    // remove cate 3 dropdown data on change of cat 2

    setState((prev) => ({
      ...prev,
      categoryThreeId: { ...prev.categoryThreeId, [`row_${i}`]: [] },
      categoryFourId: { ...prev.categoryFourId, [`row_${i}`]: [] },
      index: i,
    }));

    setCat4Data((prev) => ({
      ...prev,
      [`row_${i}`]: [],
    }));
    setValue(`placeholderManagement[${i}].category3`, null, {
      shouldValidate: false,
    });

    setValue(`placeholderManagement[${i}].category4`, null, {
      shouldValidate: false,
    });

    setSelected((prev) => ({
      ...prev,
      [`placeholderManagement[${i}].category3`]: null,
      [`placeholderManagement[${i}].category4`]: null,
    }));

    // set cat 3 value in form
    setValue(`placeholderManagement[${i}].category2`, value, {
      shouldValidate: true,
    });

    setSelected((prev) => ({
      ...prev,
      [`placeholderManagement[${i}].category2`]: value,
    }));
    const cat2Ids = value.value;
    setState((prev) => ({
      ...prev,
      categoryTwoId: { ...prev.categoryTwoId, [`row_${i}`]: cat2Ids },
      index: i,
    }));
  };

  const handleCatThreeOnChange = async (value, i) => {
    setValue(`placeholderManagement[${i}].category4`, null, {
      shouldValidate: false,
    });

    setSelected((prev) => ({
      ...prev,
      [`placeholderManagement[${i}].category4`]: null,
    }));

    // set cat 4 value in form
    setValue(`placeholderManagement[${i}].category3`, value, {
      shouldValidate: true,
    });

    setSelected((prev) => ({
      ...prev,
      [`placeholderManagement[${i}].category3`]: value,
    }));

    const cat3Ids = value.value;
    setState((prev) => ({
      ...prev,
      categoryThreeId: { ...prev.categoryThreeId, [`row_${i}`]: cat3Ids },
      index: i,
    }));
  };

  const handleCatFourOnChange = async (value, i) => {
    setValue(`placeholderManagement[${i}].category4`, value, {
      shouldValidate: true,
    });

    setSelected((prev) => ({
      ...prev,
      [`placeholderManagement[${i}].category4`]: value,
    }));

    const cat4Ids = value.value;
    setState((prev) => ({
      ...prev,
      categoryFourId: { ...prev.categoryFourId, [`row_${i}`]: cat4Ids },
      index: i,
    }));
  };

  const handleProductDescOnChange = async (value, i) => {
    setValue(`placeholderManagement[${i}].productDescription`, value, {
      shouldValidate: true,
    });

    setSelected((prev) => ({
      ...prev,
      [`placeholderManagement[${i}].productDescription`]: value,
    }));
  };

  const handleBrandOnChange = async (value, i) => {
    setValue(`placeholderManagement[${i}].brands`, value, {
      shouldValidate: true,
    });

    setSelected((prev) => ({
      ...prev,
      [`placeholderManagement[${i}].brands`]: value,
    }));
  };

  const handleSeasonOnChange = async (value, i) => {
    setValue(`placeholderManagement[${i}].seasons`, value, {
      shouldValidate: true,
    });

    setSelected((prev) => ({
      ...prev,
      [`placeholderManagement[${i}].seasons`]: value,
    }));
  };

  const handleMonthOnChange = async (value, i) => {
    setValue(`placeholderManagement[${i}].month`, value, {
      shouldValidate: true,
    });

    setSelected((prev) => ({
      ...prev,
      [`placeholderManagement[${i}].month`]: value,
    }));
  };

  const handleYearOnChange = async (value, i) => {
    setValue(`placeholderManagement[${i}].year`, value, {
      shouldValidate: true,
    });

    setSelected((prev) => ({
      ...prev,
      [`placeholderManagement[${i}].year`]: value,
    }));
  };

  const handleNewnessTypeOnChange = async (value, i) => {
    setValue(`placeholderManagement[${i}].newnessType`, value, {
      shouldValidate: true,
    });

    setSelected((prev) => ({
      ...prev,
      [`placeholderManagement[${i}].newnessType`]: value,
    }));
  };

  const handleSustainabilityOnChange = async (value, i) => {
    setValue(`placeholderManagement[${i}].sustainability`, value, {
      shouldValidate: true,
    });

    setSelected((prev) => ({
      ...prev,
      [`placeholderManagement[${i}].sustainability`]: value,
    }));
  };

  const handlePriceBrandOnChange = async (value, i) => {
    setValue(`placeholderManagement[${i}].priceBrand`, value, {
      shouldValidate: true,
    });

    setSelected((prev) => ({
      ...prev,
      [`placeholderManagement[${i}].priceBrand`]: value,
    }));
  };

  const addRow = () => {
    placeholderManagementAppend({
      category1: [],
      category2: [],
      brands: [],
    });
  };

  const removeRow = (i) => {
    placeholderManagementRemove(i);
  };

  // all useEffect collection
  useEffect(() => {
    if (data.length) {
      setState((prev) => ({ ...prev, fieldsData: data[0] }));
    }
    if (data.length && placeholderManagementFields.length === 0) addRow();
  }, [data]); // eslint-disable-line

  useEffect(() => {
    nextCategory(1);
  }, [state.categoryOneId]); // eslint-disable-line

  useEffect(() => {
    nextCategory(2);
  }, [state.categoryTwoId]); // eslint-disable-line

  useEffect(() => {
    nextCategory(3);
  }, [state.categoryThreeId]); // eslint-disable-line

  return (
    <table className="table custom-table layout-fixed font-13">
      <thead>
        <tr>
          {tableHeaders?.map((item, i) => {
            return (
              <th key={i} className="w-250px">
                {item.name}
              </th>
            );
          })}
          <th className="w-140px">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="border-0" colSpan={6}>
            {isLoading && <Loader />}
          </td>
        </tr>
        {!isLoading &&
          placeholderManagementFields &&
          placeholderManagementFields?.map((_item, i) => {
            return (
              <tr key={i}>
                <td>
                  <FormGroup className="mb-2">
                    <div className="custom-react-select flex-fill">
                      <Select
                        name={`placeholderManagement[${i}].category1`}
                        disabled={loaderOnSubmit}
                        {...register(`placeholderManagement[${i}].category1`, {
                          required: true,
                        })}
                        options={state?.fieldsData?.category1 || []}
                        value={selected?.[`placeholderManagement[${i}].category1`] || null}
                        styles={customStyles}
                        labelledBy="Select Category 1"
                        onChange={(val) => {
                          handleCatOneOnChange(val, i);
                        }}
                      />
                    </div>

                    {errors.placeholderManagement?.[i]?.category1 && (
                      <small className="error-message">
                        {errors.placeholderManagement?.[i]?.category1?.message
                          ? errors.placeholderManagement?.[i]?.category1?.message
                          : 'Category 1 is required'}
                      </small>
                    )}
                  </FormGroup>
                </td>
                <td>
                  <FormGroup className="mb-2">
                    <div className="custom-react-select">
                      <Select
                        name={`placeholderManagement[${i}].category2`}
                        {...register(`placeholderManagement[${i}].category2`, {
                          required: true,
                        })}
                        options={state?.fieldsData?.category2 || []}
                        value={selected?.[`placeholderManagement[${i}].category2`] || null}
                        styles={customStyles}
                        labelledBy="Select Category 2"
                        onChange={(val) => {
                          handleCatTwoOnChange(val, i);
                        }}
                      />
                    </div>
                    {errors.placeholderManagement?.[i]?.category2 && (
                      <small className="error-message">
                        {errors.placeholderManagement?.[i]?.category2?.message
                          ? errors.placeholderManagement?.[i]?.category2?.message
                          : 'Category 2 is required'}
                      </small>
                    )}
                  </FormGroup>
                </td>
                <td>
                  <FormGroup className="mb-2">
                    <div className="custom-react-select flex-fill">
                      <Select
                        name={`placeholderManagement[${i}].category3`}
                        {...register(`placeholderManagement[${i}].category3`, {
                          required: true,
                        })}
                        options={cat3Data?.[`row_${i}`] || []}
                        value={selected?.[`placeholderManagement[${i}].category3`] || null}
                        styles={customStyles}
                        labelledBy="Select Category 3"
                        onChange={(val) => {
                          handleCatThreeOnChange(val, i);
                        }}
                      />
                    </div>

                    {errors.placeholderManagement?.[i]?.category3 && (
                      <small className="error-message">
                        {errors.placeholderManagement?.[i]?.category3?.message
                          ? errors.placeholderManagement?.[i]?.category3?.message
                          : 'Category 3 is required'}
                      </small>
                    )}
                  </FormGroup>
                </td>
                <td>
                  <FormGroup className="mb-2">
                    <div className="custom-react-select flex-fill">
                      <Select
                        name={`placeholderManagement[${i}].category4`}
                        {...register(`placeholderManagement[${i}].category4`, {
                          required: false,
                        })}
                        options={cat4Data?.[`row_${i}`] || []}
                        value={selected?.[`placeholderManagement[${i}].category4`] || null}
                        styles={customStyles}
                        labelledBy="Select Category 4"
                        onChange={(val) => {
                          handleCatFourOnChange(val, i);
                        }}
                      />
                    </div>

                    {errors.placeholderManagement?.[i]?.category4 && (
                      <small className="error-message">
                        {errors.placeholderManagement?.[i]?.category4?.message
                          ? errors.placeholderManagement?.[i]?.category4?.message
                          : 'Category 3 is required'}
                      </small>
                    )}
                  </FormGroup>
                </td>
                <td>
                  <FormGroup className="mb-2">
                    <div className="custom-react-select ">
                      <Select
                        name={`placeholderManagement[${i}].productDescription`}
                        {...register(`placeholderManagement[${i}].productDescription`, {
                          required: true,
                        })}
                        options={state?.fieldsData?.productDescription || []}
                        value={selected?.[`placeholderManagement[${i}].productDescription`] || null}
                        styles={customStyles}
                        labelledBy="Select Product Description"
                        onChange={(val) => {
                          handleProductDescOnChange(val, i);
                        }}
                      />
                    </div>

                    {errors.placeholderManagement?.[i]?.productDescription && (
                      <small className="error-message">
                        {errors.placeholderManagement?.[i]?.productDescription?.message
                          ? errors.placeholderManagement?.[i]?.productDescription?.message
                          : 'Product Description is required.'}
                      </small>
                    )}
                  </FormGroup>
                </td>
                <td>
                  <FormGroup className="mb-2">
                    <div className="custom-react-select ">
                      <Select
                        name={`placeholderManagement[${i}].brands`}
                        {...register(`placeholderManagement[${i}].brands`, {
                          required: true,
                        })}
                        options={state?.fieldsData?.brands || []}
                        value={selected?.[`placeholderManagement[${i}].brands`] || null}
                        styles={customStyles}
                        labelledBy="Select Brands"
                        onChange={(val) => {
                          handleBrandOnChange(val, i);
                        }}
                      />
                    </div>
                    {errors.placeholderManagement?.[i]?.brands && (
                      <small className="error-message">
                        {errors.placeholderManagement?.[i]?.brands?.message ? errors.placeholderManagement?.[i]?.brands?.message : ' Brands is required.'}
                      </small>
                    )}
                  </FormGroup>
                </td>
                <td>
                  <FormGroup className="mb-2">
                    <div className="custom-react-select">
                      <Select
                        name={`placeholderManagement[${i}].seasons`}
                        {...register(`placeholderManagement[${i}].seasons`, {
                          required: true,
                        })}
                        options={state?.fieldsData?.seasons || []}
                        value={selected?.[`placeholderManagement[${i}].seasons`] || null}
                        styles={customStyles}
                        labelledBy="Select Seasons"
                        onChange={(val) => {
                          handleSeasonOnChange(val, i);
                        }}
                      />
                    </div>

                    {errors.placeholderManagement?.[i]?.seasons && (
                      <small className="error-message">
                        {errors.placeholderManagement?.[i]?.seasons?.message ? errors.placeholderManagement?.[i]?.seasons?.message : 'Seasons is required.'}
                      </small>
                    )}
                  </FormGroup>
                </td>
                <td>
                  <FormGroup className="mb-2">
                    <div className="custom-react-select ">
                      <Select
                        name={`placeholderManagement[${i}].month`}
                        {...register(`placeholderManagement[${i}].month`, {
                          required: true,
                        })}
                        options={state?.fieldsData?.month || []}
                        value={selected?.[`placeholderManagement[${i}].month`] || null}
                        styles={customStyles}
                        labelledBy="Select month"
                        onChange={(val) => {
                          handleMonthOnChange(val, i);
                        }}
                      />
                    </div>

                    {errors.placeholderManagement?.[i]?.month && (
                      <small className="error-message">
                        {errors.placeholderManagement?.[i]?.month?.message ? errors.placeholderManagement?.[i]?.month?.message : 'Month is required.'}
                      </small>
                    )}
                  </FormGroup>
                </td>
                <td>
                  <FormGroup className="mb-2">
                    <div className="custom-react-select ">
                      <Select
                        name={`placeholderManagement[${i}].year`}
                        {...register(`placeholderManagement[${i}].year`, {
                          required: true,
                        })}
                        options={state?.fieldsData?.year || []}
                        value={selected?.[`placeholderManagement[${i}].year`] || null}
                        styles={customStyles}
                        labelledBy="Select year"
                        onChange={(val) => {
                          handleYearOnChange(val, i);
                        }}
                      />
                    </div>

                    {errors.placeholderManagement?.[i]?.year && (
                      <small className="error-message">
                        {errors.placeholderManagement?.[i]?.year?.message ? errors.placeholderManagement?.[i]?.year?.message : 'Year is required.'}
                      </small>
                    )}
                  </FormGroup>
                </td>
                <td>
                  <FormGroup className="mb-2">
                    <div className="custom-react-select ">
                      <Select
                        name={`placeholderManagement[${i}].newnessType`}
                        {...register(`placeholderManagement[${i}].newnessType`, {
                          required: true,
                        })}
                        options={state?.fieldsData?.newnessType || []}
                        value={selected?.[`placeholderManagement[${i}].newnessType`] || null}
                        styles={customStyles}
                        labelledBy="Select NewnessType"
                        onChange={(val) => {
                          handleNewnessTypeOnChange(val, i);
                        }}
                      />
                    </div>

                    {errors.placeholderManagement?.[i]?.newnessType && (
                      <small className="error-message">
                        {errors.placeholderManagement?.[i]?.newnessType?.message
                          ? errors.placeholderManagement?.[i]?.newnessType?.message
                          : 'Newness Type is required.'}
                      </small>
                    )}
                  </FormGroup>
                </td>
                <td>
                  <FormGroup className="mb-2">
                    <div className="custom-react-select ">
                      <Select
                        name={`placeholderManagement[${i}].sustainability`}
                        {...register(`placeholderManagement[${i}].sustainability`, {
                          required: true,
                        })}
                        options={state?.fieldsData?.sustainability || []}
                        value={selected?.[`placeholderManagement[${i}].sustainability`] || null}
                        styles={customStyles}
                        labelledBy="Select Sustainability"
                        onChange={(val) => {
                          handleSustainabilityOnChange(val, i);
                        }}
                      />
                    </div>

                    {errors.placeholderManagement?.[i]?.sustainability && (
                      <small className="error-message">
                        {errors.placeholderManagement?.[i]?.sustainability?.message
                          ? errors.placeholderManagement?.[i]?.sustainability?.message
                          : 'Sustainability Type is required.'}
                      </small>
                    )}
                  </FormGroup>
                </td>
                <td>
                  <FormGroup className="mb-2">
                    <div className="custom-react-select ">
                      <Select
                        name={`placeholderManagement[${i}].priceBrand`}
                        {...register(`placeholderManagement[${i}].priceBrand`, {
                          required: true,
                        })}
                        options={state?.fieldsData?.priceBrand || []}
                        value={selected?.[`placeholderManagement[${i}].priceBrand`] || null}
                        styles={customStyles}
                        labelledBy="Select PriceBrand"
                        onChange={(val) => {
                          handlePriceBrandOnChange(val, i);
                        }}
                      />
                    </div>

                    {errors.placeholderManagement?.[i]?.priceBrand && (
                      <small className name="error-message">
                        {errors.placeholderManagement?.[i]?.priceBrand?.message
                          ? errors.placeholderManagement?.[i]?.priceBrand?.message
                          : 'Price Brand Type is required.'}
                      </small>
                    )}
                  </FormGroup>
                </td>
                <td>
                  <FormGroup className="mb-2">
                    <div>
                      <input
                        className="form-control"
                        name={`placeholderManagement[${i}].targetPrice`}
                        {...register(`placeholderManagement[${i}].targetPrice`, {
                          required: true,
                        })}
                        placeholder="Target Price"
                      />
                    </div>

                    {errors.placeholderManagement?.[i]?.targetPrice && (
                      <small className="error-message">
                        {errors.placeholderManagement?.[i]?.targetPrice?.message
                          ? errors.placeholderManagement?.[i]?.targetPrice?.message
                          : ' Target Price Type is required.'}
                      </small>
                    )}
                  </FormGroup>
                </td>
                <td>
                  <FormGroup className="mb-2">
                    <div>
                      <input
                        className="form-control "
                        name={`placeholderManagement[${i}].placeholderQuanity`}
                        {...register(`placeholderManagement[${i}].placeholderQuanity`, {
                          required: true,
                        })}
                        placeholder="Placeholder Quanity"
                      />
                    </div>
                    {errors.placeholderManagement?.[i]?.placeholderQuanity && (
                      <small className="error-message">
                        {errors.placeholderManagement?.[i]?.placeholderQuanity?.message
                          ? errors.placeholderManagement?.[i]?.placeholderQuanity?.message
                          : 'Placeholder Quanity Type is required.'}
                      </small>
                    )}
                  </FormGroup>
                </td>
                <td>
                  <FormGroup className="mb-2">
                    <div className="custom-react-select ">55%</div>
                  </FormGroup>
                </td>
                <td>
                  <div className="d-flex">
                    <button
                      type="button"
                      title={t('COMMON_LABEL.ADD')}
                      aria-label={t('COMMON_LABEL.ADD')}
                      className="filter-btn filter-button_delete"
                      onClick={() => addRow()}
                    >
                      <i className="icon-add" />
                    </button>

                    {placeholderManagementFields && placeholderManagementFields.length > 1 && (
                      <button
                        type="button"
                        className="filter-btn filter-button_delete"
                        onClick={() => removeRow(i)}
                        title={t('COMMON_LABEL.DELETE')}
                        aria-label={t('COMMON_LABEL.DELETE')}
                      >
                        <i className="icon-delete" />
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
}

export default List;
